var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download blue 20x20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download--24x24",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-blue-20x20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.712472,16.870536 C22.7053153,16.5146308 22.9880309,16.2203105 23.343936,16.213152 L23.351712,16.213044 C23.7119204,16.2151322 24.0022364,16.5088275 24.0001897,16.869036 L24.0001897,23.33304 C24.0037805,23.6956849 23.7143152,23.9934157 23.351712,24 L0.639396,24 C0.278945515,23.9925872 -0.0072500415,23.6943786 1.54448525e-05,23.333928 L1.54448525e-05,23.33304 L1.54448525e-05,16.870536 C-0.00700066719,16.5146308 0.275714859,16.2203105 0.63162,16.213152 L0.639396,16.213044 C0.99960911,16.2151256 1.28993239,16.5088229 1.287852,16.869036 L1.287852,22.675548 L22.712472,22.675548 L22.712472,16.870536 Z M18.173916,12.55866 C18.4293841,12.2977131 18.4293841,11.8804149 18.173916,11.619468 C18.0625951,11.4996018 17.908217,11.428867 17.744743,11.4228246 C17.581269,11.4167822 17.4220902,11.475927 17.302224,11.587248 L17.270004,11.619468 L12.639972,16.3728 L12.639972,0.66696 C12.6437625,0.493859877 12.5786307,0.326344342 12.4589061,0.201268174 C12.3391816,0.0761920059 12.1746724,0.00380180376 12.001572,2.4e-05 L12.000672,2.4e-05 C11.6380688,0.00660826576 11.3486035,0.304339134 11.352228,0.666984 L11.352228,16.3728 L6.7314,11.619468 C6.49373332,11.3673166 6.09665809,11.3555722 5.844504,11.593236 L5.818272,11.619468 C5.56281663,11.8804201 5.56281663,12.2977079 5.818272,12.55866 L11.544396,18.44826 C11.6643095,18.5693492 11.8274143,18.637843 11.9978289,18.638681 C12.1682435,18.6395038 12.3320082,18.5726028 12.453096,18.452688 L12.457524,18.44826 L18.173916,12.55866 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.6138f03f2090e25df99f6733d4412cb9.svg";